import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IDistributor } from "@app/distributor/models/IDistributor";
import { Api } from "@app/shared/config/Api";
import { ErrorService } from "@app/shared/services/error/error.service";
import { catchError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DistributorService {
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  api = new Api();

  getUserById(id: string) {
    return this.http
      .get<IDistributor>(`${this.api.getHostV1()}/distributors/${id}/`)
      .pipe(catchError(this.errorService.handleError));
  }
  getCompanyUserById(companyId: string, id: string) {
    return this.http
      .get<IDistributor>(
      `${this.api.getHostV1()}/companies/${companyId}/users/${id}/`
    )
      .pipe(catchError(this.errorService.handleError));
  }

  updateUser(id: string, data: FormData) {
    return this.http
      .put<FormData>(`${this.api.getHostV1()}/distributors/${id}/`, data)
      .pipe(catchError(this.errorService.handleError));
  }
}
